import type { CustomCellRendererProps } from "ag-grid-react";
import type { Nullable } from "src/ts-types";
import EditButton from "../EditButton";

interface EditButtonCellRendererProps extends CustomCellRendererProps {
  data: { id: number };
  onEdit?: (id: number) => void;
}

export const EditButtonCellRenderer = ({
  data,
  onEdit,
}: EditButtonCellRendererProps): Nullable<React.ReactElement> => {
  if (!onEdit) return null;
  return <EditButton id={data.id} onEdit={onEdit} />;
};
